import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditUserTotalBalance({ open, onClose, user, fetchUsers }) {
  const [newValue, setNewValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = useCallback(async () => {
    if (!newValue.trim()) {
      toast.error("Balance Total Limit cannot be empty");
      return;
    }

    // ❗ Validate numeric value
    const num = Number(newValue);

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user.id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      userLimit: user.user_limit,
      userBalanceLimitPerUser: user.deposit_limit,
      totalBalanceLimit: num === null || num === undefined || num === "" ? user.deposit_limit_total : num,
    };

    try {
      const response = await backend.edit_user_limit(payload);
      if (response.error === "False") {
        toast.success(response.message);
        fetchUsers?.();
        onClose?.();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network Error, Failed to update. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [newValue]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-white rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <h2 className="text-lg font-bold text-[var(--text)]">
          ✏️ Edit User Balance Total Limit - {user.user_limit}
        </h2>

        <input
          type="number"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          className="mt-4 w-full border-1 border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder="Enter User Balance Total Limit"
        />

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-gray-200 hover:bg-gray-300 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--primary)] text-white transition"
          >
            {isLoading ? "Loading.." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
